'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';

var validateAiResume = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var msBaseUrl, accessToken, langCode, resumeId, apiUrl, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                msBaseUrl = params.msBaseUrl, accessToken = params.accessToken, langCode = params.langCode, resumeId = params.resumeId;
                apiUrl = "".concat(msBaseUrl, "/api-gateway/v1.0/ai-resume-file-extract");
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken),
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify({
                            resumeId: resumeId
                        })
                    })];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/, null];
            case 4:
                _a.sent();
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
var deleteAttachedResume = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, msBaseUrl, langCode, resumeId, API_DOWNLOAD_CV, requestOptions, response, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, langCode = params.langCode, resumeId = params.resumeId;
                API_DOWNLOAD_CV = "".concat(msBaseUrl, "/api-gateway/v1.0/profile/resume-attached?resumeId=").concat(resumeId);
                requestOptions = {
                    method: 'DELETE',
                    headers: {
                        Authorization: "Bearer ".concat(accessToken),
                        'Accept-Language': langCode
                    }
                };
                return [4 /*yield*/, fetch(API_DOWNLOAD_CV, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { deleteAttachedResume, validateAiResume };
//# sourceMappingURL=index.js.map
